// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceFilterPopup_root__2Lf8R","label":"PriceFilterPopup_label__z6dN_","labelSelected":"PriceFilterPopup_labelSelected__nLd2V"};